const initialState = {
  notifications: [],
  client_lead_cleared: [],
  setCurrentLeadPending: false,
  setCurrentLeadError: null,
  client_lead: null,
  verifiyAccountPending: false,
  verifiyAccountSuccess: false,
  verifiyAccountError: false,
  validateRestorePasswordPending:false,
  validateRestorePasswordError: null,
  validatedUserPhoneNumber: null,
  validatedUserId: null,
  restorePasswordSuccess: false,
  restorePasswordError: false,
  restorePasswordPending: false,
  verifyAccountPending: false,
  verifyAccountSuccess: false,
  verifyAccountError: false,
};

export default initialState
